module.exports = __webpack_public_path__ + "img/livros.a3a8f7fa.png";